<template>
  <div :class="$style.container">
    <!-- Breadcrumb -->
    <div class="px-3 pt-3">
      <breadcrumb :items="breadcrumbItems" />
    </div>

    <!-- Header -->
    <div v-if="!bundle" class="mb-3">
      <loading :class="['m-3', $style.loading]" height="17px" />
      <loading :class="['m-2 p-1', $style.loading]" height="14px" />
    </div>

    <template v-else>
      <master-header :title="bundle.name + ' Bundle'">
        <a
          :class="!followedByUser ? 'text-primary' : 'text-danger'"
          @click.prevent="onFollow"
          slot="action"
          href="#"
        >{{ !followedByUser ? 'Follow': "Unfollow" }}</a>
      </master-header>

      <!-- Search Input -->
      <div :class="['mb-3', $style.searchForm]">
        <input
          :value="query"
          @keydown.enter.prevent="query = $event.target.value"
          type="search"
          class="form-control border-0 form-control-lg px-3"
          placeholder="Search icon in bundle"
        />
      </div>
    </template>

    <!-- results -->
    <results
      :is-loading="isLoadingResults"
      :results="results"
      :params="searchParams"
      :class="$style.scroller"
      @loadMore="onLoadMore"
    />
  </div>
</template>

<script>
import request from '@/lib/axios'
import Breadcrumb from '@/components/ui/Breadcrumb'
import MasterHeader from '@/components/ui/Header'
import Loading from '@/components/loading'
import Results from '@/components/Results'

import AuthMixin from '@/components/mixins/auth'
import SearchMixin from '@/components/mixins/search.js'

export default {
  components: {
    Breadcrumb,
    MasterHeader,
    Loading,
    Results,
  },

  mixins: [AuthMixin, SearchMixin],

  data() {
    return {
      asset: 'icon',
      bundle: null,
      followedByUser: null,
      breadcrumbItems: [],
    }
  },

  async mounted() {
    await this.fetchBundle()
    this.createBreadcrumb()
    this.fetch()
  },

  computed: {
    searchParams() {
      return {
        product_type: 'item',
        asset: this.asset,
        ...this.$route.query,
        ...(this.bundle && { bundle_uuids: [this.bundle.uuid] }),
      }
    },

    query: {
      get() {
        return this.$route.query.query || null
      },
      set(value) {
        this.$router.push({
          name: this.$route.name,
          params: this.$route.params,
          query: {
            ...this.$route.query,
            query: value,
          },
        })
      },
    },
  },

  methods: {
    async fetchBundle() {
      this.isLoadingResults = true

      const results = await request({
        route: 'bundle',
        params: {
          slug: this.$route.params.slug,
          featured: false,
        },
      })
      this.bundle = results.data.response.bundle

      this.followedByUser = this.bundle.followed_by_user
      this.isLoadingResults = false
    },

    createBreadcrumb() {
      const breadcrumbItems = [
        {
          text: 'Home',
          to: { name: 'icons-slug' },
        },
      ]

      breadcrumbItems.push({
        text: this.bundle.contributor.name,
        to: {
          name: 'contributor-username',
          params: {
            username: this.bundle.contributor.username,
          },
          query: {
            asset: this.bundle.asset,
          },
        },
      })

      this.breadcrumbItems = breadcrumbItems
    },

    async onFollow() {
      if (this.handleAuth()) {
        this.followedByUser = !this.followedByUser

        await request({
          route: 'bundle.follow',
          method: 'post',
          params: {
            uuid: this.bundle.uuid,
          },
        })

        this.$store.dispatch('user/fetchFollowingBundles')
      }
    },
  },
}
</script>

<style lang="scss" module>
.container {
  .scroller {
    height: 0;
    flex-grow: 1;
  }

  .searchForm {
    border-top: 1px solid var(--border-2);
    border-bottom: 1px solid var(--border-2);
  }

  .loading {
    div {
      margin: auto;
    }
  }
}
</style>
